module.exports = __webpack_public_path__ + "static/WelcomeToElk6-63d0bc6312fdcf35c1702a4eae9c4165.png";